import React from 'react'

type Props = {
  percent: number
  size?: number
  strokeWidth?: number
  trackColor?: string
  valueColor?: string
  textColor?: string
}

const CircularProgress: React.FC<Props> = ({
  percent,
  size = 42,
  strokeWidth = 4,
  trackColor = '#e5e7eb',
  valueColor = '#f79421',
  textColor = '#111827',
}) => {
  const normalizedPercent = Math.max(0, Math.min(100, Math.round(percent)))
  const center = size / 2
  const radius = Math.max(1, center - strokeWidth)
  const circumference = 2 * Math.PI * radius
  const dashOffset = circumference - (normalizedPercent / 100) * circumference

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-hidden='true'>
      <circle
        cx={center}
        cy={center}
        r={radius}
        fill='none'
        stroke={trackColor}
        strokeWidth={strokeWidth}
      />
      <circle
        cx={center}
        cy={center}
        r={radius}
        fill='none'
        stroke={valueColor}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeDasharray={circumference}
        strokeDashoffset={dashOffset}
        transform={`rotate(-90 ${center} ${center})`}
      />
      <text
        x='50%'
        y='50%'
        dominantBaseline='middle'
        textAnchor='middle'
        style={{
          fill: textColor,
          fontSize: `${Math.max(10, size * 0.26)}px`,
          fontWeight: 700,
        }}
      >
        {normalizedPercent}%
      </text>
    </svg>
  )
}

export default CircularProgress
